import {
  ArticleOutlined,
  AutoAwesomeOutlined,
  FavoriteBorderOutlined,
  FitnessCenterOutlined,
  FlightOutlined,
  LaptopMacOutlined,
  LinkOutlined,
  LocalMoviesOutlined,
  MenuBookOutlined,
  MusicNoteOutlined,
  PermMediaOutlined,
  RestaurantOutlined,
  SchoolOutlined,
  ShoppingBagOutlined,
  SportsEsportsOutlined,
  SportsSoccerOutlined,
} from '@mui/icons-material';
import { SvgIconComponent } from '@mui/icons-material';

export const COLLECTION_NAME = 'HubLinks';

export interface LinkItem {
  id: string;
  label: string;
  to: string;
}

// One Firestore doc per section; links are kept in display order.
export interface LinkSection {
  id: string;
  title: string;
  icon: string;
  order: number;
  links: LinkItem[];
}

// Icons are stored by key, since components can't go in Firestore.
export const SECTION_ICONS: Record<string, SvgIconComponent> = {
  news: ArticleOutlined,
  work: LaptopMacOutlined,
  media: PermMediaOutlined,
  gaming: SportsEsportsOutlined,
  shopping: ShoppingBagOutlined,
  misc: AutoAwesomeOutlined,
  music: MusicNoteOutlined,
  movies: LocalMoviesOutlined,
  books: MenuBookOutlined,
  sport: SportsSoccerOutlined,
  fitness: FitnessCenterOutlined,
  food: RestaurantOutlined,
  travel: FlightOutlined,
  learning: SchoolOutlined,
  favourites: FavoriteBorderOutlined,
  link: LinkOutlined,
};

export const getSectionIcon = (key: string) => SECTION_ICONS[key] ?? LinkOutlined;

export const newId = () => crypto.randomUUID();

export const isValidUrl = (url: string) => /^https?:\/\/\S+$/i.test(url.trim());
